<template>
  <div class="app-main-inner">
    <div class="section">
      <span class="title">{{ $t('SeaExport.CustomsDeclarationInfo') }}</span>
      <div style="display:flex;flex-direction:column;width:500px;">
        <el-form :disabled="readonly" label-width="60px" label-position="left">
          <el-form-item :label="$t('SeaExport.CustomsBroker')" class="auto-width">
            <cargo-company-select
              :method-params="{customsBroker:true,seaExport:true,active:true}"
              :default-value="job.customsBroker||''"
              @change="p=>{job.customsBroker=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Remarks')" class="auto-width">
            <el-input v-model="job.customsRemarks" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <div class="operations">
        <div class="triggers">
          <div>
            <el-button no="NewCustomsDeclaration" type="primary" :disabled="!btnEnable" @click="addCustInfoHandler">{{ $t('SeaExport.NewCustomsDeclaration') }}</el-button>
            <el-button no="EditCustomsDeclaration" type="primary" :disabled="!btnEnable" @click="editCustInfoHandler">{{ $t('SeaExport.EditCustomsDeclaration') }}</el-button>
            <el-button no="DeleteCustomsDeclaration" type="primary" :disabled="!btnEnable" @click="delCustInfoHandler">{{ $t('SeaExport.DeleteCustomsDeclaration') }}</el-button>
          </div>
        </div>
      </div>
      <div style="flex-grow:1;padding-top:10px">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;height:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 编辑弹框 -->
    <customs-info-dialog-ouj ref="customsInfoDialogOuj" :visible.sync="editDialog.visible" :selected-customs-info="selectedCustomsInfo" :job="job" @successHandler="successHandler" />
    <!-- 海关回执弹窗 -->
    <customs-info-interact-res-dialog ref="customsInfoInteractResDialog" :visible.sync="interactResDialog.visible" :customs-id="interactResDialog.customsId" />
    <!-- 回执文件弹窗 -->
    <file-history-dialog ref="fileHistoryDialog" :visible.sync="fileHistoryDialog.visible" :customs-id="fileHistoryDialog.customsId" />
  </div>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { customsList, customsInfoDeleteAll } from '@/api/seaExport/customsInfo'
import { File } from '@/class/model/booking/File'
import customsInfoDialogOuj from '@/components/Cargo/Job/booking/tabs/ouJian/customsInfoDialogOuj'
import customsInfoInteractResDialog from '@/components/Cargo/Job/booking/tabs/ouJian/customsInfoInteractResDialog'
import fileHistoryDialog from '@/components/Cargo/Job/booking/tabs/ouJian/fileHistoryDialog'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { saveFile } from '@/api/seaExport/file'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Job } from '@/class/model/booking/Job'
import StrUtils from '@/utils/StrUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { queryFileByOriginFileId } from '@/api/seaExport/file'
import { getJobByUuid } from '@/api/booking/job'

export default {
  name: 'TabCustomsInfo',
  components: { customsInfoDialogOuj, customsInfoInteractResDialog, fileHistoryDialog, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      form: {
        uuid: ''
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.onRowClicked,
        onCellClicked: this.showInteractRes
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BlNo'),
          field: 'mbl',
          width: 120,
          hide: !this.isShowUploadFile
        },
        {
          headerName: this.$t('SeaExport.OperatingCompany'),
          field: 'companyCname',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.CustomsCode'),
          field: 'tenDigitCode',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DateOfCustomsDeclaration'),
          field: 'customsDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptState'),
          field: 'interactRes',
          width: 140,
          cellRenderer: (params) => {
            return '<a>' + params.value + '</a>'
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsReceiptFile'),
          width: 140,
          field: 'fileHistory',
          cellRenderer: (params) => {
            return '<a>' + this.$t('SeaExport.ViewFile') + '</a>'
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'),
          field: 'dateModified',
          width: 150
        },
        {
          headerName: this.$t('SeaExport.StatusOfCustomsDeclaration'),
          field: 'declareCustomsState',
          width: 120,
          cellRenderer: (params) => {
            return this.customsStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CommodityInspectionOrNot'),
          field: 'commodityInspection',
          width: 120,
          cellRenderer: (params) => {
            return this.commodityLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsInspectionOrNot'),
          field: 'spotInspection',
          width: 120,
          cellRenderer: (params) => {
            return this.commodityLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.CustomsNo'),
          field: 'customsNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      editDialog: {
        visible: false
      },
      interactResDialog: {
        visible: false,
        customsId: '111'
      },
      fileHistoryDialog: {
        visible: false,
        customsId: '111'
      },
      currentUser: {},
      job: new Job().fillDefaultValue().getData(),
      isShowUploadFile: false,
      selectedCustomsInfo: {},
      isNew: false,
      lockButton: false,
      btnEnable: false
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }

      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      this.job = row

      if (row.uuid) {
        this.display()
        // 加载列表数据
        this.loadList()
      }
    },
    display() {
      this.btnEnable = false
      if (!StrUtils.isEmpty(this.job.uuid)) {
        // todo printHblZbLock job上的此属性暂未赋值
        // this.lockButton = this.job.printHblZbLock
        this.btnEnable = true
      }
      //  enabled="{!lockButton && job&&  !job.isNewInstance()}"
    },
    fillMode() {
      // todo 报关空运相关的
      /* if(job is AirExportJob)
      {
        AirExportJob(job).actualFlight = txtActualFlight.text;
        job.ATD = dfDateATD.selectedDate;
        AirExportJob(job).onwardJourney = txtOnwardJourney.text;
      }
      JobUtils.synCustomsBroker(job,job.customsBroker,0);*/
    },
    getSubmitData() {
      this.fillMode()
      const job = { ...this.job }
      return {
        job
      }
    },
    async loadList() {
      await customsList(this.job.uuid).then(res => {
        this.rowData = res.data
      })
      this.selectedCustomsInfo = {}
      this.gridApi.clearFocusedCell()
    },
    customsStateLabFun(declareCustomsState) {
      if (declareCustomsState === 1) {
        return this.$t('SeaExport.Recorded')
      } else if (declareCustomsState === 2) {
        return this.$t('SeaExport.ListPulled')
      } else if (declareCustomsState === 3) {
        return this.$t('SeaExport.AtReception')
      } else if (declareCustomsState === 4) {
        return this.$t('SeaExport.CustomsDeclared')
      } else if (declareCustomsState === 5) {
        return this.$t('SeaExport.Undeclared')
      } else if (declareCustomsState === 6) {
        return this.$t('SeaExport.CustomsExamination')
      } else if (declareCustomsState === 7) {
        return this.$t('SeaExport.InspectionExamination')
      } else if (declareCustomsState === 8) {
        return this.$t('SeaExport.ExamedWithoutReleasing')
      } else if (declareCustomsState === 9) {
        return this.$t('SeaExport.AmendDeclaration')
      } else if (declareCustomsState === 10) {
        return this.$t('SeaExport.NotifyToDeclare')
      } else if (declareCustomsState === 11) {
        return this.$t('SeaExport.CustomsHasCheck')
      } else if (declareCustomsState === 12) {
        return this.$t('SeaExport.CustomsExamed')
      } else if (declareCustomsState === 13) {
        return this.$t('SeaExport.CustomsOneRelease')
      } else if (declareCustomsState === 14) {
        return this.$t('SeaExport.CustomsRelease2')
      }
      return this.$t('SeaExport.UnknownState')
    },
    commodityLabFun(commodityInspection) {
      const val = Boolean(commodityInspection)
      if (val) {
        return this.$t('Message.Yes')
      }
      return this.$t('Message.No')
    },
    // 新增报关单
    addCustInfoHandler() {
      this.$nextTick(() => {
        this.$refs.customsInfoDialogOuj.onShow('add')
        this.isNew = true
        this.editDialog.visible = true
      })
    },
    onRowClicked(event) {
      this.selectedCustomsInfo = event.data
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedCustomsInfo = node.data
          }
        })
      }
    },
    // 编辑报关单
    editCustInfoHandler() {
      var arr = Object.keys(this.selectedCustomsInfo)
      if (arr.length === 0) {
        this.$message.info(this.$t('Message.SelectCustomsInformation'))
        return
      }
      this.$nextTick(() => {
        this.$refs.customsInfoDialogOuj.onShow('edit')
        this.isNew = false
        this.editDialog.visible = true
      })
    },
    // 新增/编辑成功都走这里
    async successHandler(data) {
      // 重新 设置选中行，避免编辑仍是上次旧值
      // this.$nextTick(() => {
      //   if (!StrUtils.isEmpty(this.selectedCustomsInfo.uuid)) {
      //     this.setGridSelect(this.selectedCustomsInfo.uuid)
      //   }
      // })

      if (this.isNew) {
        this.addFile(data)
        this.isNew = false
      }
      await this.loadList()
    },
    // 设置 选中行
    setGridSelect(uuid) {
      const nodes = this.gridApi.getRenderedNodes()
      if (uuid) {
        for (const item of nodes) {
          if (uuid === item.data.uuid) {
            item.setSelected(true)
            this.selectedCustomsInfo = item.data
            break
          }
        }
      }
    },
    addFile(customsInfo) {
      const file = new File().fillDefaultValue().getData()
      file.jobUuid = this.job.uuid
      file.jobNo = this.job.jobNo
      file.fileType = String(FileType.BGD_TYPE.code)
      file.tenDigitCode = customsInfo.tenDigitCode
      file.companyCname = customsInfo.companyCname
      file.customsBroker = customsInfo.customsBroker
      file.fileNo = customsInfo.soNo
      file.customsNo = customsInfo.customsNo
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.customerId)
      file.receiveDate = new Date()
      file.receiveCompany = companyCache ? companyCache.chineseName : ''
      file.receivePerson = this.job.customerContact
      file.receiveTel = this.job.contactTelephone
      file.expressAddress = companyCache.address
      file.state = 0
      file.branchId = this.job.opOffice
      file.inputBy = this.currentUser.userId
      file.inputByDep = this.$store.getters.currentDeptId
      file.inputDate = new Date()
      file.tax = false
      file.originFileId = customsInfo.uuid
      file.currentHolder = this.currentUser.userId
      file.remark = customsInfo.remarks
      saveFile(file)
    },
    delCustInfoHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = Array.from(rows, p => p.uuid)
        customsInfoDeleteAll(uuids).then(res => {
          this.loadList()
        })
      }).catch(() => {
      })
    },
    // 查看回执历史
    showInteractRes(row) {
      console.log(row)
      if (row.colDef.field === 'interactRes') {
        this.interactResDialog.customsId = row.data.uuid
        this.interactResDialog.visible = true
      } else if (row.colDef.field === 'fileHistory') {
        queryFileByOriginFileId(row.data.uuid).then(res => {
          this.fileHistoryDialog.visible = true
          this.fileHistoryDialog.customsId = res.data.uuid
        })
      }
    }
  }
}
</script>

<style>
</style>
